// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import NodeCollapseOutlinedSvg from "@ant-design/icons-svg/es/asn/NodeCollapseOutlined";
import AntdIcon from '../components/AntdIcon';

var NodeCollapseOutlined = function NodeCollapseOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: NodeCollapseOutlinedSvg
  }));
};

NodeCollapseOutlined.displayName = 'NodeCollapseOutlined';
export default React.forwardRef(NodeCollapseOutlined);